import { logError, logInfo } from '@edx/frontend-platform/logging';
import { call, put, takeEvery } from 'redux-saga/effects';

// Actions
import {
  ACTIVATE_ACCOUNT,
  activateAccountBegin,
  activateAccountForbidden,
  activateAccountNotFound,
  activateAccountServerError,
  activateAccountSuccess,
} from './actions';
import { activateAccount } from './service';

// Services
export function* handleActivateAccount(action) {
  try {
    yield put(activateAccountBegin());

    yield call(activateAccount, action.payload.usernameEmail);
    yield put(activateAccountSuccess(action.payload.usernameEmail));
  } catch (e) {
    if (e.response && e.response.status === 403) {
      yield put(activateAccountForbidden());
      logInfo(e);
    } else if (e.response && e.response.status === 400) {
      const responseData = e.response.data || {};
      const errorMessage = responseData.response || responseData.message || 'User not found.';
      yield put(activateAccountNotFound(errorMessage, responseData.error_code));
      logInfo(e);
    } else {
      yield put(activateAccountServerError());
      logError(e);
    }
  }
}

export default function* saga() {
  yield takeEvery(ACTIVATE_ACCOUNT.BASE, handleActivateAccount);
}
